import {RealtimeEventType} from '@sollapay/enums';
import {useQueryClient} from '@tanstack/react-query';

import {useRealtimeEvent} from '@/hooks/useRealtimeEvent';

import {invalidateBuyerCaches} from '../utils';

/** Keeps another open session's buyer roster in sync after someone else deletes a buyer. */
export function useBuyerRealtimeUpdates(): void {
  const queryClient = useQueryClient();

  useRealtimeEvent(RealtimeEventType.BuyerRemoved, event => {
    invalidateBuyerCaches(queryClient, event.trustAccountId, [event.buyerPartyId]);
  });
}
